 <template>
    <div class="container">
      <div class="row  align-items-center" style="padding:25px 0px 5px 0px;background-color:#fff;">
        <div class="col-lg-6 text-center">
          <img src="../../assets/home/factsheets.svg" class="img-fluid">
        </div>
        <div class="col-lg-6">
          <div id="features-left">
          <ul>
          <li>Create thematic factsheets with information on vegetation, agriculture, soils, weather, climate, and land use.
          <li>Factsheets contain interactive charts and maps.</li>
          <li>Global coverage and based on open datasets.</li>
          <li>Source data available for download.</li>
          </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
    }
  },
  components: {},
  name: 'Teaser'
}
</script>

<style>
</style>

<style scoped>
   div#features-left, div#features-right {
      height:100%;
      display:flex;
      align-items:center;
    }
    div#features-left li {
      text-align:left;
    }
    div#features-right li {
      text-align:left;
    }
    div#features-left li, div#features-right li {
      font-size:1.2em;
      color:#777;
      font-weight:700;
      padding-bottom:10px;
      padding-top:10px;
    }
    div#features-left ul, div#features-right ul {
      list-style-type: none;
    }
    div#features-left ul li:before, div#features-right ul li:before {   
      font-family: 'FontAwesome';
      content: '\f00c';
      margin:0 5px 0 -22px;
      font-weight:300;
    }
</style>
